import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class AnuncioExternoService extends DefaultService {
  
  constructor() {
    super('anuncioexterno');
  }

  getBystablecimientoE(id: string): Promise<any>{
    return API.get(`anuncioexterno/establecimiento/${id}`);
  }

  getByContribuyente(filters: any): Promise<any>{
      let query = new URLSearchParams(filters).toString();
      return API.get(`anuncioexterno/contribuyente`+ '?' + query);
  }

  changeStatus(id: number, data: any): Promise<any>{
    return API.post(`anuncioexterno/${id}/changestatus`, data);
  }

  viewPrintedRequest(url: any, data: any, type: any, name: string){
    return API.request({
        url: url,
        data: data,
        method: type,
        responseType: 'blob'
    });
  }

  deleteDetalle(id: any): Promise<any> {
    return API.delete(`/anuncioexterno/${id}/detalle`);
  }

    generarFmtAutorizacion(url: any, type: any, name: string): Promise<any>{
        return API.request({
            url,
            method: type,
            responseType: 'blob'
        })
    }

    updateSolicitud(id: number, data: any): Promise<any>{
        return API.post(`anuncioexterno/${id}/updatesolicitud`, data);
    }

    createAnuncio(data: any): Promise<any>{
        return API.post(`anuncioexterno/createanuncio`, data);
    }

}

export default new AnuncioExternoService;